import { render, staticRenderFns } from "./FooterInside.vue?vue&type=template&id=a74d56f2&scoped=true&"
import script from "./FooterInside.vue?vue&type=script&lang=js&"
export * from "./FooterInside.vue?vue&type=script&lang=js&"
import style0 from "./FooterInside.vue?vue&type=style&index=0&id=a74d56f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74d56f2",
  null
  
)

export default component.exports